import React, { ChangeEvent } from "react";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";

type MainInputProps = {
  label?: string;
  value?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  marginTop?: number;
  onFocus?: () => void;
  onBlur?: () => void;
};

function MainInput({
  label,
  value,
  onChange,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onFocus,
  onBlur,
}: MainInputProps) {
  return (
    <div
      className="otherInput"
      style={{ marginBottom, marginLeft, marginRight, marginTop }}
    >
      <CustomText
        size="small"
        weight="500"
        color={Colors.primary}
        marginBottom={10}
      >
        {label}
      </CustomText>
      {/* <input
        type="text"
        value={value}
        onChange={onChange}
        className="otherRegistrationInput"
        onFocus={onFocus}
      /> */}
      <div
        className="otherRegistrationInput"
        style={{ display: "flex", alignItems: "center" }}
      >
        <input
          type="text"
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className="otherRegistrationPhoneInput"
          style={{ width: "100%", paddingLeft: 0 }}
        />
      </div>
    </div>
  );
}

export default MainInput;
